import { render, staticRenderFns } from "./server-bind-floating-ip.vue?vue&type=template&id=e5bc2254&scoped=true&"
import script from "./server-bind-floating-ip.vue?vue&type=script&lang=js&"
export * from "./server-bind-floating-ip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bc2254",
  null
  
)

export default component.exports